module.exports = __webpack_public_path__ + "8d721a911a4ffab0eb1d10da4781765d.MP3";